export const pipe = (fn, ...fns) => (...args) =>
  fns.reduce((acc, fn) => fn(acc), fn(...args));
export const isEmpty = obj => !obj && !Object.keys(obj).length > 0;
export const orEmptyString = value => value || "";
export const noop = () => {};
export const numberToArray = n => [...Array(n).keys()];



// WEBPACK FOOTER //
// ./src/helpers/functional.js